import { Box, Button, Typography } from '@mui/material';
import { t } from 'i18next';
import useGetFlexRequestHistory from '../hooks/useGetFlexRequestHistory';
import dayjs from 'dayjs';
import { GridColDef } from '@mui/x-data-grid-pro';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { FlexHistoryRequest } from 'RestAPIs/flex-history';
import { Icon } from '@sdb/planning-ui';

const FlexRequestHistoryTable = ({
  processInstanceId,
  setShowTaskHistory,
  showTaskHistory
}) => {
  const { data: rows, isFetching: isFetchingRows } =
    useGetFlexRequestHistory(processInstanceId);

  const columns: GridColDef[] = [
    {
      field: 'taskDefinitionKey',
      headerName: t('flexHistory.taskHistory.taskName'),
      flex: 1,
      valueGetter: (_, row: FlexHistoryRequest) =>
        t(`flexHistory.taskHistory.taskNames.${row.taskDefinitionKey}`, {
          defaultValue: row.taskDefinitionKey
        })
    },
    {
      field: 'assignee',
      headerName: t('flexHistory.taskHistory.assignee'),
      width: 150
    },
    {
      field: 'performedAction',
      headerName: t('flexHistory.taskHistory.reply'),
      width: 100,
      valueGetter: (_, row: FlexHistoryRequest) =>
        row.performedAction &&
        t(`flexHistory.taskHistory.replies.${row.performedAction}`, {
          defaultValue: row.performedAction
        })
    },
    {
      field: 'startTime',
      headerName: t('flexHistory.taskHistory.start'),
      width: 160,
      valueGetter: (_, row: FlexHistoryRequest) =>
        dayjs(row.startTime).format('D MMMM YYYY HH:mm')
    },
    {
      field: 'endTime',
      headerName: t('flexHistory.taskHistory.end'),
      width: 160,
      valueGetter: (_, row: FlexHistoryRequest) =>
        dayjs(row.endTime).format('D MMMM YYYY HH:mm')
    }
  ];

  return isFetchingRows ? (
    <>{t('loading...')}</>
  ) : (
    <Box mb={1}>
      <Button
        onClick={() => {
          setShowTaskHistory(!showTaskHistory);
        }}
        color="primary"
        size="small"
        variant="text"
        sx={{ display: 'flex', gap: 1, textTransform: 'none', mb: 0.5 }}
      >
        <Typography variant="h6" component="h4">
          {t('flexHistory.taskHistory.title')}
        </Typography>
        {showTaskHistory ? (
          <Icon type="chevron-up" fontSize="inherit" color="inherit" />
        ) : (
          <Icon type="chevron-down" fontSize="inherit" color="inherit" />
        )}
      </Button>
      {showTaskHistory && (
        <TableCRUDLayout
          rows={rows || []}
          getRowId={(row) => row.id}
          shouldRenderToolBar={true}
          columns={columns}
          dynamicHeight={true}
          pageSize={5}
          disableRowSelectionOnClick
          hideFooter={rows && rows?.length < 5}
          disableActions={true}
        />
      )}
    </Box>
  );
};

export default FlexRequestHistoryTable;
